"use strict";

var _regeneratorRuntime = require("/codebuild/output/src013157826/src/gardner/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime.js");

var _asyncToGenerator = require("/codebuild/output/src013157826/src/gardner/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/codebuild/output/src013157826/src/gardner/node_modules/@babel/runtime/helpers/slicedToArray");

var _defineProperty = require("/codebuild/output/src013157826/src/gardner/node_modules/@babel/runtime/helpers/defineProperty");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSuccessIndicator = exports.ProgressIndicator = void 0;

var theme_ui_1 = require("theme-ui");

var react_transition_group_1 = require("react-transition-group");

var icons_1 = require("./icons");

var react_1 = __importStar(require("react"));

var async_1 = require("../common/async");

var successIndicatorClass = "successIndicator";

var ProgressIndicator = function ProgressIndicator(_ref) {
  var _sx;

  var processingState = _ref.processingState,
      isSuccess = _ref.isSuccess;
  return react_1.default.createElement(theme_ui_1.Flex, {
    sx: (_sx = {
      alignItems: "center"
    }, _defineProperty(_sx, ".".concat(successIndicatorClass, "-enter"), {
      opacity: 0.01,
      transform: "scale(1.1)"
    }), _defineProperty(_sx, ".".concat(successIndicatorClass, "-enter-active"), {
      opacity: 1,
      transform: "scale(1)",
      transition: "all 1000ms"
    }), _sx)
  }, react_1.default.createElement(react_transition_group_1.TransitionGroup, {
    component: null
  }, isSuccess ? react_1.default.createElement(react_transition_group_1.CSSTransition, {
    classNames: successIndicatorClass,
    timeout: 300
  }, react_1.default.createElement(icons_1.Success, {
    height: "4em"
  })) : react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(theme_ui_1.Spinner, null), react_1.default.createElement(theme_ui_1.Box, {
    sx: {
      textAlign: "center",
      flexGrow: 1
    }
  }, processingState))));
};

exports.ProgressIndicator = ProgressIndicator;

var useSuccessIndicator = function useSuccessIndicator() {
  var indicationDurationMs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2000;

  var _react_1$useState = react_1.useState(false),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      isSuccess = _react_1$useState2[0],
      setIsSuccess = _react_1$useState2[1];

  return [isSuccess, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            setIsSuccess(true);
            _context.next = 3;
            return async_1.delay(indicationDurationMs);

          case 3:
            setIsSuccess(false);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }))];
};

exports.useSuccessIndicator = useSuccessIndicator;